import { OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { takeUntilDestroy } from 'take-until-destroy';
import { ContactPageComponent } from '../../../components/contact.us.page/contact-page.component';
import { ChangePasswordComponent } from "../../../change.password/components/change.password.component";
import { LogoutReason } from "../../../../app-auth/common/common.types";
import { AboutPageComponent } from "../../../components/about.page/about.page.component";
var LanguageSelectionComponent = /** @class */ (function () {
    function LanguageSelectionComponent(intlServicePP, authProviderService, patientAccountPreferencesService, router, popupWindowService, appConfigService) {
        this.intlServicePP = intlServicePP;
        this.authProviderService = authProviderService;
        this.patientAccountPreferencesService = patientAccountPreferencesService;
        this.router = router;
        this.popupWindowService = popupWindowService;
        this.appConfigService = appConfigService;
        this.languages = [];
        this.languageOptionsClosed = true;
        this.showTheTooltip = false;
    }
    Object.defineProperty(LanguageSelectionComponent.prototype, "isAuthenticated", {
        get: function () {
            return this.authProviderService.isAuthenticated();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LanguageSelectionComponent.prototype, "isInternalAuthentication", {
        get: function () {
            return !this.appConfigService.Config.externalAuthentication;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LanguageSelectionComponent.prototype, "firstName", {
        get: function () {
            return this.authProviderService.currentPatient.firstName;
        },
        enumerable: true,
        configurable: true
    });
    LanguageSelectionComponent.prototype.ngOnDestroy = function () { };
    LanguageSelectionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.intlServicePP.getUsedLanguageObservable().pipe(takeUntilDestroy(this)).subscribe(function (lang) {
            if (lang) {
                _this.selectedLanguage = lang;
                _this.languages = !_this.languages.length ? _this.intlServicePP.cachedLanguages
                    .filter(function (l) { return (l.isActive && l.usage.toUpperCase() !== 'R') || l.isDefault; })
                    .sort(function (l1, l2) { return l1.language >= l2.language ? 1 : -1; }) : _this.languages;
            }
        });
    };
    LanguageSelectionComponent.prototype.logoutClickHandler = function () {
        this.authProviderService.logout(LogoutReason.Manual);
    };
    LanguageSelectionComponent.prototype.showContactUsPage = function () {
        this.popupWindowService
            .openPopupWindow(ContactPageComponent, this.contactUsTitle, window.outerWidth - 20, window.outerHeight - 20, 10, 10)
            .pipe(takeUntilDestroy(this))
            .subscribe(function (result) {
            if (result === true) {
            }
        });
    };
    LanguageSelectionComponent.prototype.showAboutPage = function () {
        this.popupWindowService
            .openPopupWindow(AboutPageComponent, this.aboutTitle, window.outerWidth - 20, window.outerHeight - 20, 10, 10)
            .pipe(takeUntilDestroy(this))
            .subscribe(function (result) {
            if (result === true) {
            }
        });
    };
    LanguageSelectionComponent.prototype.changePassword = function () {
        this.popupWindowService
            .openPopupWindow(ChangePasswordComponent, this.changePasswordTitle, window.outerWidth - 20, window.outerHeight - 20, 10, 10, { userName: this.authProviderService.currentPatient.accountDetails.userName })
            .pipe(takeUntilDestroy(this))
            .subscribe(function (result) {
        });
    };
    LanguageSelectionComponent.prototype.languageSelectedHandler = function (lang) {
        this.intlServicePP.setLanguage(lang, false, true);
        if (this.authProviderService.isAuthenticated()) {
            this.patientAccountPreferencesService.setDefaultAccountLanguage(lang.languageKey);
        }
    };
    LanguageSelectionComponent.prototype.languagesToggleHandler = function (e) {
        this.languageOptionsClosed = !this.languageOptionsClosed;
        e.stopPropagation();
    };
    LanguageSelectionComponent.prototype.setInitialState = function () {
        this.showTheTooltip = false;
        this.languageOptionsClosed = true;
    };
    return LanguageSelectionComponent;
}());
export { LanguageSelectionComponent };
